<!--
 * @Author: zyy
 * @Date: 2022-11-16 16:08:46
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-16 17:18:54
 * @Description: default
-->


<template>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmmodal"
        destroy-on-close centered :width="1000">

        <div class="modal-box">
            <a-card>
                <a-table :columns="columns" :data-source="modal.data" rowKey="id" :pagination="false">
                    <span slot="goods" slot-scope="data">
                        <div class="flex">
                            <div><img :src="data.goods_image" alt="" height="40" width="40"></div>
                            <div style="margin-left:10px">
                                <div>{{ data.goods_title }}</div>
                                <div style="font-size: 12px;color:#686767;">规格:{{ data.goods_sku_text }}</div>
                            </div>
                        </div>
                    </span>
                </a-table>
                <div class="flex line-height-30 mt-20">
                    <div class="mr-20"></div>
                    <div>
                        <div>配送方式:111</div>
                        <div>退款金额:111</div>
                        <div>售后单号:111</div>
                        <div>申请时间:111</div>
                    </div>
                </div>

                <div class="flex line-height-30 mt-20">
                    <div class="mr-20"></div>
                    <div>
                        <div>订单编号:111</div>
                        <div>用户信息:111</div>
                        <div>联系方式:111</div>
                        <div>物流状态:111</div>
                        <div>运费金额:111</div>
                        <div>优惠金额:111</div>
                        <div>实付金额:111</div>
                    </div>
                </div>
            </a-card>

            <a-card style="margin:40px 0">
                <div style="padding:70px;" class="border-bottom">
                    <a-steps :current="2" size="small">
                        <a-step title="买家申请售后" description="2022-12-12" />
                        <a-step title="售后申请处理中" description="2022-12-12" />
                        <a-step title="未处理" description="2022-12-12" />
                    </a-steps>
                </div>

                <div style="margin:30px 70px">
                    <div style="font-size: 22px;">
                        <a-icon type="info-circle" style="margin-right: 20px;color:#7438D5"/>
                        <span style="font-weight: 600;">未处理</span>
                    </div>
                    <div class="line-height-40" style="margin-bottom: 20px;">买家申请了售后，请尽快处理</div>
                    <div>
                        <a-button type="primary" class="mr-30">同意退款</a-button>
                        <a-button class="mr-30">拒绝申请</a-button>
                        <a-button type="link">售后完成</a-button>
                    </div>
                    <div style="margin-top: 70px;">
                        <span class="line-height-30">温馨提示：</span>
                        <div class="gray">
                            <div class="line-height-30">1、如果同意申请，请发送正确的退货地址给买家。</div>
                            <div class="line-height-30">2、如果拒绝申请，请发送给买家拒绝理由。</div>
                        </div>
                    </div>
                </div>
            </a-card>

            <a-card>
                <div >
                    <div class="flex line-height-40" style="justify-content: space-between;">
                        <span>售后记录</span>
                        <a-button type="link">点击回复</a-button>
                    </div>
                    <div class="line-height-40">
                        <span class="mr-20" style="font-weight: 600;">您的售后服务单已申请成功，等待售后处理</span>
                        <span class="gray">2022-11-14 17:38:25</span>
                    </div>
                    <div class="mt-20 gray line-height-30">申请原因:大小/重量于商品描述不符</div>
                    <div class="gray line-height-30">相关描述:休息休息</div>
                </div>
            </a-card>

        </div>

    </a-modal>

</template>
<script>


export default {
    props: ['submit'],
    data() {
        return {
            info:{},
            modal: {
                loading: false,
                show: false,
                data: []
            },
            columns: [
                {
                    title: "商品",
                    key: "goods",
                    scopedSlots: { customRender: "goods" },
                    width: 400
                },
                {
                    title: "数量",
                    dataIndex: "goods_num",
                    key: "goods_num",
                    width: 100
                }

            ]
        }
    },
    methods: {
        confirmmodal() {
            this.modal.show = false
            this.$emit('submit')
        }
    }

}
</script>
<style scoped lang="less">
.border-bottom {
    border-bottom: 1px solid #e8e8e8;
}

.modal-box {
    max-height: 600px;
    overflow: hidden;
    overflow-y: auto;

}

.flex {
    display: flex;
}

.flex-center {
    display: flex;
    align-items: center;
}

.mr-20 {
    margin-right: 20px;
}
.mr-30 {
    margin-right: 30px;
}

.mt-20 {
    margin-top: 20px;
}

.line-height-30 {
    line-height: 30px;
}
.line-height-40 {
    line-height: 30px;
}
.gray {
    color: #999;
}
</style>